'use client'
import { ReactNode, useCallback, useContext } from 'react'

import {
  ToastNotificationContext,
  defaultToastNotificationState,
} from '../providers/toast-notification-provider'

import { TToastNotificationType } from '@/components/shared/toast-notification'

const useToastNotification = () => {
  const toast = useContext(ToastNotificationContext)

  const onClose = useCallback(() => {
    if (toast?.onClose) {
      toast.onClose()
    }
  }, [toast])

  const show = useCallback(
    ({
      autoclose = true,
      ...state
    }: {
      type: TToastNotificationType
      title: string
      content?: ReactNode
      traceId?: string
      disableClose?: boolean
      disableIcon?: boolean
      onClose?: () => void
      autoCloseDuration?: number
      autoclose?: boolean
    }) => {
      if (toast?.setState) {
        const { setState } = toast

        setState({ show: true, ...state })

        if (autoclose) {
          setTimeout(
            () => {
              setState({ ...defaultToastNotificationState })
            },
            state?.autoCloseDuration ?? 5000,
          )
        }
      }
    },
    [toast],
  )

  return {
    show,
    close: onClose,
  }
}

export default useToastNotification
